import * as React from 'react'

import type { LinearComponentProps } from 'react-chartjs-2'

// Lazy on purpose: react-chartjs-2/chart.js can be bundled before Module
// Federation's eager shared React graph is ready, leaving undefined minified
// bindings in the mobile bootstrap chunk.
const LazyLineChart = React.lazy(async () => ({
  default: (await import('react-chartjs-2')).Line,
}))

export const LineChart: React.FC<LinearComponentProps> = props => (
  <React.Suspense fallback={null}>
    <LazyLineChart {...props} />
  </React.Suspense>
)
